import React, { Component } from "react";
import { URLS } from "../../urls";
import { Link } from "react-router-dom";
import "../../../assets/css/sidebar.css";
class UserSidebar extends Component {
  render() {
    return (
      <div className="sidebar" id="sidebar">
        <div className="sidebar-inner slimscroll">
          <div id="sidebar-menu" className="sidebar-menu">
            <ul>
              {/* {
                <li className="submenu-sidebar mt-4">
                  <Link to={URLS.employeeDashboard} className="side-anchor">
                    <span className="icon">
                      <i className="la la-dashboard"></i>
                    </span>
                    <span>Dashboard</span>
                  </Link>
                </li>
              } */}
              <li className="submenu-sidebar mt-2">
                <Link to={URLS.userDashboardProfile} className="side-anchor">
                  <span className="icon">
                    <i className="la la-users"></i>
                  </span>
                  <span>Profile</span>
                </Link>
              </li>
              {/* <li>
                <Link to={URLS.userDashboardProjects}>
                  <i className="la la-rocket"></i> <span>Contracts</span>
                </Link>
              </li>
              <li>
                <Link to={URLS.userDashboardProjects}>
                  <i className="la la-rocket"></i> <span>Projects</span>
                </Link>
              </li>
              <li>
                <a href={URLS.userDashboardTasks}>
                  <i className="la la-tasks"></i> <span>Tasks</span>
                </a>
              </li>
              <li>
                <Link to={URLS.userDashboardPerformance}>
                  <i className="la la-balance-scale"></i>{" "}
                  <span>Performance</span>
                </Link>
              </li>
              <li>
                <Link to={URLS.userDashboardTeams}>
                  <i className="la la-group"></i> <span>Teams</span>
                </Link>
              </li>
              <li>
                <a
                  href="http://app.petrobasegroup.com/calendar"
                  target="_blank"
                >
                  <i className="la la-calendar"></i>{" "}
                  <span>Calendar & Events</span>
                </a>
              </li>
              <li> 
								<a href="/dashboard/inbox"><i className="la la-at"></i> <span>Email</span></a>
							</li>
              <li>
                <a
                  href="http://app.petrobasegroup.com/messenger"
                  target="_blank"
                >
                  <i className="la la-comments"></i> <span>Chat</span>
                </a>
              </li> */}
              <li className="submenu-sidebar mt-2">
                <Link to={URLS.userDashboardPolicy} className="side-anchor">
                  <span className="icon">
                    <i className="la la-file-pdf-o"></i>
                  </span>
                  <span>Policies</span>
                </Link>
              </li>
              <li className="submenu-sidebar mt-2">
                <Link to={URLS.userDashboardLeaves} className="side-anchor">
                  <span className="icon">
                    <i className="la la-hourglass-start"></i>
                  </span>
                  <span>Leaves</span>
                </Link>
              </li>
              <li className="submenu-sidebar mt-2">
                <Link to={URLS.userDashboardLoan} className="side-anchor">
                  <span className="icon">
                    <i className="la la-money"></i>
                  </span>
                  <span>Loan</span>
                </Link>
              </li>
              <li className="submenu-sidebar mt-2">
                <Link to={URLS.userDashboardAllowance} className="side-anchor">
                  <span className="icon">
                    <i className="la la-tasks"></i>
                  </span>
                  <span>Allowance</span>
                </Link>
              </li>
              <li className="submenu-sidebar mt-2">
                <Link
                  to={URLS.userDashboardMyAttendance}
                  className="side-anchor"
                >
                  <span className="icon">
                    <i className="fa fa-calendar"></i>
                  </span>
                  <span>My attendance</span>
                </Link>
              </li>
              <li className="submenu-sidebar mt-2">
                <a
                  href={`${URLS.mainSite}/requisition/request`}
                  className="side-anchor"
                >
                  <span className="icon">
                    <i className="la la-check-square-o"></i>
                  </span>
                  <span>Forms/Approval</span>
                </a>
              </li>
              <li
                className="submenu-sidebar mt-2"
                // className={
                //   activeTab === "permission"
                //     ? "submenu-sidebar side-active"
                //     : "submenu-sidebar"
                // }
                // onClick={() => setActiveTab("permission")}
              >
                <Link to={URLS.userDashboardPermission} className="side-anchor">
                  <span className="icon">
                    <i className="la la-check-square-o"></i>
                  </span>
                  <span>Permission</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default UserSidebar;
